import { MEMBER_UPDATE_MUTATION } from 'apollo/mutations/member-mutations';
import { MEMBER_FLAT_QUERY } from 'apollo/queries/member-queries';
import { useApolloPaging, useOrganizationUpdate } from 'hooks';
import useMemberUpdate from 'hooks/models/member/useMemberUpdate';
import { useCallback } from 'react';
import { NonNullArrayField } from 'types/util/NonNullArrayField';
import { QueryFlatMemberNameQuery } from '__generated__/graphql';
import useGustoDeleteToken from '../../authentication/useGustoDeleteToken/useGustoDeleteToken';

export default function useGustoDisconnectAccount() {
  const deleteToken = useGustoDeleteToken();
  const [updateMemberKey] = useMemberUpdate(MEMBER_UPDATE_MUTATION);
  const [updateOrganizationKey] = useOrganizationUpdate();
  const { getAll } = useApolloPaging();

  return useCallback(async () => {
    const currentBusyMembers = await getAll<NonNullArrayField<QueryFlatMemberNameQuery['members']>>('members', {
      query: MEMBER_FLAT_QUERY,
    });
    await Promise.all(currentBusyMembers.map(({ id }) => updateMemberKey(id, 'gustoEmployeeId', null)));
    await updateOrganizationKey('gustoCompanyId', null);
    return await deleteToken();
  }, [deleteToken, getAll, updateMemberKey, updateOrganizationKey]);
}
